export const PathRoutes = {
    home: '/',
    chat: '/chat',
    dashboard: '/dashboard',
    suscription: '/dashboard/subscriptions',
    promotions: '/dashboard/promotions',
    inmobiliaria: '/dashboard/real-estate',
    companyPartner: '/dashboard/company-partners',
    userAdminUnit: '/dashboard/user-admin-unit',
    onboarding: '/onboarding',
}